import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

const authUrl = process.env.REACT_APP_AUTH_URL;

const API_URL_LOGIN = authUrl + "/api/v1/admin_login";
const API_URL_LOGOUT = authUrl + "/api/v1/admin_logout";

const API_URL_ORDER_STATUS = baseUrl + "/api/v1/order/count_since_last_logout";
const API_URL_ORDERDISTRIBUTION_STATUS = baseUrl + "/api/v1/order/status_list";

// Get Order Status
// @GET
const getDistributionStatus = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDERDISTRIBUTION_STATUS, null, config);
  const newToken = res.headers.authorization;
  return { res, newToken };
};

// Get Order Status
// @GET
const getOrderStatus = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_ORDER_STATUS, null, config);

  return res.data;
};

// Get Order
// @POST
const getToken = async (data) => {
  const res = await axios.post(API_URL_LOGIN, data);

  return res;
};

// Logout
// @GET
const logout = async (token) => {
  const config = {
    headers: {
      Authorization: token,
    },
  };

  const res = await axios.post(API_URL_LOGOUT, null, config);

  return res;
};

const saveService = {
  getToken,
  logout,
  getOrderStatus,
  getDistributionStatus,
};

export default saveService;
